import { Merchant, MerchantStatus } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';
import { SWRConfig } from 'swr';

import { ApproveByCommercialMessage } from '@/components/widgets/MerchantDetailActions/components/ApproveByCommercialMessage';
import { ApproveByRiskMessage } from '@/components/widgets/MerchantDetailActions/components/ApproveByRiskMessage';
import { ChangeMerchantStatus } from '@/components/widgets/MerchantDetailActions/components/ChangeMerchantStatus';
import { MerchantDetailAction } from '@/components/widgets/MerchantDetailActions/types/MerchantDetailAction';

interface MerchantDetailDialogProps {
  merchant: Merchant;
  currentAction: MerchantDetailAction;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
}

export const MerchantDetailDialog = ({
  merchant,
  currentAction,
  opened,
  setOpened,
  toggleDialog,
}: MerchantDetailDialogProps) => {
  return (
    <>
      <SWRConfig value={{ revalidateOnMount: false }}>
        {currentAction === MerchantDetailAction.APPROVE_BY_COMMERCIAL && (
          <ApproveByCommercialMessage
            merchant={merchant}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {currentAction === MerchantDetailAction.APPROVE_BY_RISK && (
          <ApproveByRiskMessage merchant={merchant} opened={opened} setOpened={setOpened} handleClose={toggleDialog} />
        )}
        {currentAction === MerchantDetailAction.SUSPEND_ACTION && (
          <ChangeMerchantStatus
            merchant={merchant}
            newMerchantStatus={MerchantStatus.STATUS_SUSPENDED}
            currentAction={currentAction}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {currentAction === MerchantDetailAction.BAN_ACTION && (
          <ChangeMerchantStatus
            merchant={merchant}
            newMerchantStatus={MerchantStatus.STATUS_BANNED}
            currentAction={currentAction}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {currentAction === MerchantDetailAction.REACTIVATE_ACTION && (
          <ChangeMerchantStatus
            merchant={merchant}
            newMerchantStatus={MerchantStatus.STATUS_DOCUMENTS_COMPLETED}
            currentAction={currentAction}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
      </SWRConfig>
    </>
  );
};
